import { ApiHttpService } from '../../services'

export const JobOrderModule = {
    namespaced: true,
    state: {
        record: null,
        loading: false,
        saving: false,
        error: null,
    },
    mutations: {
        setRecord(state, payload) { state.record = payload },
        setLoading(state, payload) { state.loading = payload },
        setSaving(state, payload) { state.saving = payload },
        setError(state, payload) { state.error = payload },
    },
    actions: {
        async getByTransaction({ commit }, transactionId) {
            commit('setError', null)
            const response = await ApiHttpService.getRequest('job-orders', {
                transaction_id: transactionId,
                length: 100,
                page: 1,
            })
            return response.data.data || []
        },
        async getAvailableItems({ commit }, payload) {
            commit('setError', null)
            const response = await ApiHttpService.getRequest(
                `job-orders/transactions/${payload.transaction_id}/available-items`,
                payload.exclude_job_order_id ? { exclude_job_order_id: payload.exclude_job_order_id } : {}
            )
            return response.data.data || []
        },
        async createFromTransaction({ commit }, payload) {
            commit('setSaving', true)
            commit('setError', null)
            try {
                const response = await ApiHttpService.postRequest('job-orders/from-transaction', payload)
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } catch (error) {
                commit('setError', error)
                throw error
            } finally {
                commit('setSaving', false)
            }
        },
        async getRecord({ commit }, id) {
            commit('setLoading', true)
            commit('setError', null)
            try {
                const response = await ApiHttpService.getRequest(`job-orders/${id}`)
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } catch (error) {
                commit('setError', error)
                throw error
            } finally {
                commit('setLoading', false)
            }
        },
        async updateRecord({ commit }, payload) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.update(`job-orders/${payload.id}`, payload)
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
        async updateStatus({ commit }, payload) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.update(`job-orders/${payload.id}/status`, payload)
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
        async releaseJobOrder({ commit }, id) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.postRequest(`job-orders/${id}/release`, {})
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
        async holdJobOrder({ commit }, payload) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.postRequest(`job-orders/${payload.id}/hold`, { reason: payload.reason })
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
        async resumeJobOrder({ commit }, id) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.postRequest(`job-orders/${id}/resume`, {})
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
        async closeJobOrder({ commit }, id) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.postRequest(`job-orders/${id}/close`, {})
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
        async cancelJobOrder({ commit }, payload) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.postRequest(`job-orders/${payload.id}/cancel`, { reason: payload.reason })
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
        async updateItem({ commit, state }, payload) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.update(`job-orders/${payload.job_order_id}/items/${payload.id}`, payload)
                const item = response.data.data || response.data
                if (state.record && Array.isArray(state.record.items)) {
                    const index = state.record.items.findIndex(row => row.id === item.id)
                    if (index >= 0) commit('setRecord', { ...state.record, items: state.record.items.map((row, rowIndex) => rowIndex === index ? item : row) })
                }
                return item
            } finally {
                commit('setSaving', false)
            }
        },
        async startJobOrderItem({ commit }, payload) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.postRequest(
                    `job-orders/${payload.job_order_id}/items/${payload.id}/start`,
                    payload
                )
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
        async completeJobOrderItem({ commit }, payload) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.update(
                    `job-orders/${payload.job_order_id}/items/${payload.id}`,
                    payload
                )
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
        async holdJobOrderItem({ commit }, payload) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.postRequest(
                    `job-orders/${payload.job_order_id}/items/${payload.id}/hold`,
                    payload
                )
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
        async resumeJobOrderItem({ commit }, payload) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.postRequest(
                    `job-orders/${payload.job_order_id}/items/${payload.id}/resume`,
                    {}
                )
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
        async cancelJobOrderItemQuantity({ commit }, payload) {
            commit('setSaving', true)
            try {
                const response = await ApiHttpService.postRequest(
                    `job-orders/${payload.job_order_id}/items/${payload.id}/cancel-quantity`,
                    payload
                )
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
        async bulkJobOrderItemsAction({ commit }, payload) {
            commit('setSaving', true)
            try {
                const request = Object.assign({}, payload)
                delete request.job_order_id
                const response = await ApiHttpService.postRequest(
                    `job-orders/${payload.job_order_id}/items/bulk-action`,
                    request
                )
                const record = response.data.data || response.data
                commit('setRecord', record)
                return record
            } finally {
                commit('setSaving', false)
            }
        },
    },
    getters: {
        record: state => state.record,
        loading: state => state.loading,
        saving: state => state.saving,
        error: state => state.error,
    },
}
